import { createContext, useContext, useState, useCallback } from "react";
import { content } from "@/i18n";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("it");
  const toggle = useCallback(() => setLang((l) => (l === "it" ? "en" : l === "en" ? "ru" : "it")), []);
  const t = content[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
